export default function copyToClipboard (document, moduleHTML, appEventEmitter) {
  const textToCopy = moduleHTML.dataset.jsCopyToClipboard
  const shareIcon = moduleHTML.querySelector('[data-js-share-icon]')
  const shareCheck = moduleHTML.querySelector('[data-js-share-check]')
  const fadeOutIn = [
    { opacity: 1 },
    { opacity: 0 },
    { opacity: 1 }
  ]
  const fadeInOut = [
    { opacity: 0 },
    { opacity: 1 },
    { opacity: 0 }
  ]

  function copyOnClick (event) {
    event.preventDefault() // Applied to anchor tag so this prevents opening the link

    if ('clipboard' in navigator) {
      navigator.clipboard.writeText(textToCopy).then(() => {
        if (shareIcon && shareCheck) {
          shareIcon.animate(fadeOutIn, 3000)
          shareCheck.animate(fadeInOut, { duration: 3000, delay: 500 })
        }
      }, () => {
        window.alert('Failed to copy to clipboard, permission denied.')
      })
    } else { // Fallback for IE
      window.prompt('To copy to clipboard: Ctrl + C, Enter', textToCopy)
    }
  }

  moduleHTML.addEventListener('click', copyOnClick)
}
